import React from "react";
import { Box, Paper, Typography, CircularProgress } from "@mui/material";
import { POPPINS, HEADER_COLOR } from "./adminConstants";

const SummaryCard = ({ icon, label, value, color, loading }) => (
  <Paper
    elevation={0}
    sx={{
      flex: "1 1 148px",
      minWidth: 130,
      border: "1px solid #e8eaf0",
      borderRadius: 2,
      borderLeft: `4px solid ${color}`,
      p: 2,
      display: "flex",
      flexDirection: "column",
      gap: 0.5,
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
      <Box sx={{ color, display: "flex" }}>{icon}</Box>
      <Typography
        variant="caption"
        sx={{
          ...POPPINS,
          fontWeight: 600,
          color: "#777",
          fontSize: "0.69rem",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
        }}
      >
        {label}
      </Typography>
    </Box>
    {loading ? (
      <CircularProgress size={18} sx={{ color, mt: 0.5 }} />
    ) : (
      <Typography
        variant="h5"
        sx={{ ...POPPINS, fontWeight: 700, color: HEADER_COLOR, lineHeight: 1.3, mt: 0.25 }}
      >
        {value != null ? Number(value).toLocaleString() : "—"}
      </Typography>
    )}
  </Paper>
);

export default SummaryCard;
